const initialState = {
	code: undefined,
	partnerDataNames: [],
	partnerTokensNames: [],
	shops: {},
};

export default (brand = initialState) => {
	return brand;
};
